import React from "react"
import { Control, Controller, UseFormClearErrors } from "react-hook-form"
import { FormTextFieldProps } from "./FormTextField"

export interface WithValidateProps {
    name: string
    control?: Control<any>
    clearErrors?: UseFormClearErrors<any>
    rules?: any
    className?: string
}

export type ValidatableFormTextFieldProps = FormTextFieldProps &
    WithValidateProps

const withValidateController =
    (Component: React.ComponentType<FormTextFieldProps>) =>
    ({
        control,
        clearErrors,
        name,
        rules,
        onBlur,
        onChange,
        ...props
    }: ValidatableFormTextFieldProps) =>
        (
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({
                    field: {
                        ref,
                        onChange: onFieldChange,
                        onBlur: onFieldBlur,
                        value,
                    },
                    fieldState: { error },
                }) => (
                    <Component
                        {...props}
                        value={value}
                        name={name}
                        onBlur={(e) => {
                            onFieldBlur()
                            onBlur?.(e)
                        }}
                        onChange={(e) => {
                            clearErrors?.(name)
                            onFieldChange(e)
                            onChange?.(e)
                        }}
                        inputRef={ref}
                        fieldError={error}
                    />
                )}
            />
        )

export default withValidateController
